var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversalidad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5333f;}.cls-2{fill:#011e41;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.07,128.79a186.28,186.28,0,0,0-230.14,0L125,116.21a202.29,202.29,0,0,1,249.92,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.91,387.9a137.86,137.86,0,0,0-183.82,0L147.43,376a153.85,153.85,0,0,1,205.14,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250,427c-24.53,0-47.22-16.66-63.89-46.93-15.83-28.76-24.55-66.82-24.55-107.17s8.72-78.41,24.55-107.16c16.67-30.27,39.36-46.94,63.89-46.94h0c24.54,0,47.22,16.67,63.89,46.94,15.83,28.75,24.55,66.81,24.55,107.16s-8.72,78.41-24.55,107.17C297.22,410.34,274.54,427,250,427Zm0-292.2c-18.44,0-36.15,13.73-49.87,38.65-30.19,54.84-30.19,144.07,0,198.9C213.85,397.28,231.56,411,250,411s36.15-13.72,49.87-38.65c30.19-54.83,30.19-144.06,0-198.9C286.15,148.53,268.44,134.8,250,134.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.15,
    y: 264.9,
    width: 291.7,
    height: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 242,
    y: 121.8,
    width: 16,
    height: 291.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250,209a153.57,153.57,0,0,1-102.57-39.18l10.66-11.93a137.86,137.86,0,0,0,183.82,0l10.66,11.93A153.59,153.59,0,0,1,250,209Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250,427A154.1,154.1,0,1,1,359,163.94c60.08,60.08,60.08,157.85,0,217.93h0A153.13,153.13,0,0,1,250,427Zm0-292.2a138.1,138.1,0,1,0,97.65,235.75c53.85-53.84,53.85-141.45,0-195.3A137.2,137.2,0,0,0,250,134.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversalidad);
export default __webpack_public_path__ + "static/media/universalidad.792e4719b4f878d2f9219d31bafbd8c9.svg";
export { ForwardRef as ReactComponent };